export default __webpack_public_path__ + "static/media/BackupEcoV2DamDac.85540572.png";